import { entitySelectors } from '@store/entity/selectors';
import {
  guestPickerValidationReset,
  guestPickerValidationSelectors,
} from '@store/guestPickerValidation';
import * as roomsActions from '@store/rooms/actions';
import { FC } from 'react';
import { connect } from 'react-redux';
import { JourneyPicker } from './JourneyPicker';
import type { JourneyPickerProps } from './JourneyPicker.types';

const mapStateToProps = (state) => ({
  userProperty: entitySelectors.getProperty(state),
  shouldTriggerValidation: guestPickerValidationSelectors.getTriggerValidation(state),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchAvailability: roomsActions.fetchRoomRateAvailability(dispatch),
  guestPickerValidationReset: () => dispatch(guestPickerValidationReset()),
});

export const JourneyPickerConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyPicker) as FC<JourneyPickerProps>;
